import React from 'react'

import { ReactComponent as ImagePlaceholder } from '@sketch/icons/document-64'

import { LoadingPlaceholder } from '@sketch/components'

import { getThumbnail } from '../../../shares/ComponentsWebView/utils'

import { ImageElement } from '../../../shares/components/DocumentItem/DocumentItem.styles'
import {
  StyledStatusIcon,
  Thumbnail,
  ThumbnailWrapper,
  NoThumbnailWrapper,
} from './CollectionItem.styles'

import { CollectionItemProps } from './types'
import { isTruthy } from '@sketch/utils'

export const renderPreview = (
  props: CollectionItemProps,
  layout: 'grid' | 'list'
) => {
  const { collection } = props

  // Only show the first 4 previews
  const previews = collection.previews.slice(0, 4)

  return (
    <ThumbnailWrapper aria-label={`Collection ${collection.name}`}>
      {previews.map(({ name, file }, index) => {
        const thumbnails = (file?.thumbnails || []).filter(isTruthy)

        if (thumbnails.length === 0) {
          return (
            <NoThumbnailWrapper data-testid="collection-no-thumb" key={index}>
              <StyledStatusIcon
                key={index}
                as={ImagePlaceholder}
                aria-label="No Image available"
              />
            </NoThumbnailWrapper>
          )
        } else {
          return (
            <Thumbnail
              key={index}
              alt={name}
              customImageElement={ImageElement}
              src={getThumbnail(thumbnails)}
              loadingPlaceholder={<LoadingPlaceholder size="16px" />}
            />
          )
        }
      })}
    </ThumbnailWrapper>
  )
}
